import { EnumsValues } from '../../enums/EnumsValues';
import { FeatureFlagWrapper } from '../FeatureFlagWrapper/FeatureFlagWrapper';
import useFileUploader from '../../hooks/useFileUploader/useFileUploader';
import DocumentTable from '../../components/common/DocumentTable/DocumentTable';
import './WaybillPage.less';
import { useRef, useEffect } from 'react';
import { ActionType } from '@ant-design/pro-table';

const WaybillPage = () => {
  const { FileUploader, documentUploaded } = useFileUploader(
    EnumsValues.DocumentTypeEnum.CPE,
  );
  const actionRef = useRef<ActionType>();

  useEffect(() => {
    if (documentUploaded && actionRef.current?.reload) {
      actionRef.current.reload();
    }
  }, [documentUploaded]);

  return (
    <FeatureFlagWrapper
      featureFlag={EnumsValues.FeatureFlags.waybillPage}
      publicAccess={false}
    >
      <div className="waybill-page">
        <FileUploader />
        <DocumentTable
          documentType={EnumsValues.DocumentTypeEnum.CPE}
          actionRef={actionRef}
          exportMapKey={EnumsValues.ExportReceiptHeadersMapKeys.CPE}
        />
      </div>
    </FeatureFlagWrapper>
  );
};

export default WaybillPage;
